export default __webpack_public_path__ + "static/media/Ballroll_00068.592352f3.png";